import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const defaultLanguage: string = process.env.REACT_APP_DEFAULT_LANGUAGE || 'en';
export const supportedLanguages: string[] = ['en'];

export const i18nInit = async () => {
    const projectName: string = process.env.REACT_APP_PROJECT_NAME || 'project';
    const resources: any = {};
    supportedLanguages.forEach((language) => {
        resources[language] = {};
        resources[language][projectName] = require(`../i18n/${language}/translation.json`);
    });
    const options = {
        order: ['querystring', 'navigator'],
        lookupQuerystring: 'lang',
        caches: [],
    };

    await i18next.use(LanguageDetector).init({
        detection: options,
        resources,
        ns: [projectName],
        defaultNS: projectName,
        fallbackLng: defaultLanguage,
        interpolation: {
            escapeValue: false,
        },
    });
};
